export const isZendeskWidgetEnabled = (
  window: Window
): window is WindowWithZendeskWidget =>
  window.hasOwnProperty('zE') && (window as any).zE !== undefined;
